/**
 * FoodCardIcon — SVG recreation of the FoodQuest brand logo
 * Green rounded border, globe center, gold fork (left) + spoon (right), gold plus sign
 */
const FoodCardIcon = ({ size = 24, className = '', active = false, outline = false }) => {
  const green = outline ? 'currentColor' : (active ? '#1B8A2E' : '#2D9F40');
  const gold = outline ? 'currentColor' : '#D4A017';
  const blue = outline ? 'none' : '#4A90D9';
  const landGreen = outline ? 'currentColor' : '#5EAD5E';
  const sw = outline ? 1.5 : (active ? 2.5 : 2);

  return (
    <svg
      width={size}
      height={size * 0.75}
      viewBox="0 0 40 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Green rounded rectangle border */}
      <rect x="1.5" y="1.5" width="33" height="27" rx="4" ry="4"
        stroke={green} strokeWidth={sw} fill="none" />

      {/* Globe (simplified circle with continent hint) */}
      <circle cx="18" cy="14" r="6" fill={blue} />
      <ellipse cx="18" cy="14" rx="3.2" ry="6" fill="none" stroke={landGreen} strokeWidth="0.8" />
      <line x1="12" y1="14" x2="24" y2="14" stroke={landGreen} strokeWidth="0.8" />
      <path d="M13.5 10.5c1.5 0.5 3 0.7 5.5 0 1.5-0.4 3 0 3.5 0.3" stroke={landGreen} strokeWidth="1" fill="none" strokeLinecap="round" />
      <path d="M14 17c1.2-0.3 2.5-0.5 4 0.2 1.2 0.4 2.5 0.2 3.5-0.2" stroke={landGreen} strokeWidth="1" fill="none" strokeLinecap="round" />

      {/* Fork (left of globe) */}
      <line x1="7.5" y1="7" x2="7.5" y2="11.5" stroke={gold} strokeWidth="1.2" strokeLinecap="round" />
      <line x1="9.5" y1="7" x2="9.5" y2="11.5" stroke={gold} strokeWidth="1.2" strokeLinecap="round" />
      <path d="M7 11.5c0 1.2 0.7 2 1.5 2s1.5-0.8 1.5-2" stroke={gold} strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <line x1="8.5" y1="13.5" x2="8.5" y2="22" stroke={gold} strokeWidth="1.3" strokeLinecap="round" />

      {/* Spoon (right of globe) */}
      <ellipse cx="27.5" cy="9.5" rx="2.2" ry="3" fill={gold} />
      <line x1="27.5" y1="12.5" x2="27.5" y2="22" stroke={gold} strokeWidth="1.3" strokeLinecap="round" />

      {/* Gold plus sign (bottom-right corner) */}
      <rect x="30" y="23" width="7" height="3" rx="1.2" fill={gold} />
      <rect x="32" y="21" width="3" height="7" rx="1.2" fill={gold} />
    </svg>
  );
};

export default FoodCardIcon;
